export default __webpack_public_path__ + "static/media/back-to-first-page.13e27109.svg";